import { TrackingHandler } from '../../tracking/TrackingHandler';
import { detectFormTest } from '../../helpers/detect-form-test';
import { CaptchaSolver } from '../core/captcha';
import { fetchSubmitId } from '../core/form-state';
import { trimFormDataFields } from '../core/submission';
import { SUGAR_CRM_FIELDS } from '../core/field-contract';
export class FormSession {
    state;
    captcha = new CaptchaSolver();
    submitIdRequest = null;
    constructor(formName) {
        this.state = { formName };
    }
    get formName() {
        return this.state.formName;
    }
    start(inputName = '') {
        if (this.submitIdRequest) {
            return;
        }
        TrackingHandler.getInstance().formStart(this.state.formName, inputName);
        this.submitIdRequest = fetchSubmitId(this.state);
        this.captcha.start();
    }
    navigate(step, action = 'goto', data = {}) {
        if (detectFormTest(data)) {
            return;
        }
        TrackingHandler.getInstance().formNavigate(this.state.formName, step, action, { ...data });
    }
    async prepareData(data, exemptFields = []) {
        this.start();
        await this.submitIdRequest;
        warnAboutUnknownFields(data, exemptFields);
        return trimFormDataFields({ ...data });
    }
}
const warnAboutUnknownFields = (data, exemptFields) => {
    const unknownFields = Object.keys(data).filter((field) => !field.startsWith('_') && !SUGAR_CRM_FIELDS.includes(field) && !exemptFields.includes(field));
    if (unknownFields.length > 0) {
        console.warn('FormHandler: fields without a CRM mapping are stored in originDetails only:', unknownFields.join(', '));
    }
};
